<div class="sidenav-content">
  <div class="bcontainer2">
    <div class="main-content">

      <div class="spacer2"></div>

      <div class="containter">
        <div class="mfhd">
          <i class="fa fa-angle-left" aria-hidden="true" style="padding-right: 5px"></i>Shared workspaces
          <div class="page-description">
            A shared workspace is a place you publish memories and recipes for other people to read.
            Nothing you write lands here on its own &mdash; you share it, and only what you share is visible.
          </div>
        </div>

        <button mat-raised-button color="primary" class="btn-send clr-white" style="float: right"
          (click)="showCreate = !showCreate" title="Create a shared workspace">
          + Create
        </button>

        <div class="spacer2"></div>
        <div class="clear"></div>

        <!-- create -->
        <div class="sw-create" *ngIf="showCreate">
          <mat-form-field appearance="outline" class="sw-name">
            <mat-label>Workspace name</mat-label>
            <input matInput [(ngModel)]="newName" placeholder="Team recipes"
              (keyup.enter)="create()" [disabled]="busy" />
          </mat-form-field>
          <button mat-raised-button color="primary" class="btn-send clr-white"
            (click)="create()" [disabled]="busy">Create</button>
          <button mat-button (click)="showCreate = false; newName = ''" [disabled]="busy">Cancel</button>
          <div class="sw-hint">
            Your personal workspace can never be shared &mdash; this creates a separate one for an audience.
          </div>
        </div>

        <div class="sw-loading" *ngIf="loading">
          <mat-spinner diameter="28"></mat-spinner>
        </div>

        <ng-container *ngIf="!loading">

          <!-- invitations waiting on you -->
          <section class="sw-section" *ngIf="pending.length">
            <h3 class="sw-heading">Waiting for you</h3>
            <div class="sw-invite" *ngFor="let invite of pending">
              <div class="sw-invite-text">
                <strong>{{ invite.invitedBy }}</strong> invited you to
                <strong>{{ invite.workspaceName }}</strong>
                <div class="sw-sub">You will be able to read what is shared there &middot; {{ expiresIn(invite.expiresAt) }}</div>
              </div>
              <div class="sw-invite-actions">
                <button mat-raised-button color="primary" class="btn-send clr-white"
                  (click)="accept(invite)" [disabled]="busy">Accept</button>
                <button mat-button (click)="decline(invite)" [disabled]="busy">Decline</button>
              </div>
            </div>
          </section>

          <!-- workspaces you own -->
          <section class="sw-section">
            <h3 class="sw-heading">Workspaces you share</h3>
            <div class="sw-empty" *ngIf="!owned.length">
              You have not created a shared workspace yet.
            </div>
            <table mat-table [dataSource]="owned" class="mat-elevation-z8" *ngIf="owned.length">
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef>Workspace</th>
                <td mat-cell *matCellDef="let ws">
                  <a class="pointer routeClr" (click)="open(ws.workspaceId)">{{ ws.name }}</a>
                </td>
              </ng-container>
              <ng-container matColumnDef="members">
                <th mat-header-cell *matHeaderCellDef>People</th>
                <td mat-cell *matCellDef="let ws">{{ ws.memberCount || 1 }}</td>
              </ng-container>
              <ng-container matColumnDef="created">
                <th mat-header-cell *matHeaderCellDef>Created</th>
                <td mat-cell *matCellDef="let ws">{{ formatDate(ws.createdAt) }}</td>
              </ng-container>
              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let ws">
                  <button mat-button class="routeClr" (click)="open(ws.workspaceId)">Manage</button>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="['name', 'members', 'created', 'actions']"></tr>
              <tr mat-row *matRowDef="let row; columns: ['name', 'members', 'created', 'actions']"></tr>
            </table>
          </section>

          <!-- personal workspaces that could become shared -->
          <section class="sw-section" *ngIf="convertible.length">
            <h3 class="sw-heading">Share an existing workspace</h3>
            <div class="sw-sub sw-convert-note">
              Whatever is already in one of these becomes readable by everyone you invite.
              Your default workspace is not listed &mdash; it collects everything you write, so it
              can never be shared.
            </div>
            <div class="sw-convert" *ngFor="let ws of convertible">
              <div>{{ ws.name }}</div>
              <button mat-button class="routeClr" (click)="makeShareable(ws)" [disabled]="busy">
                Make shareable
              </button>
            </div>
          </section>

          <!-- workspaces you were invited into -->
          <section class="sw-section">
            <h3 class="sw-heading">Shared with you</h3>
            <div class="sw-empty" *ngIf="!sharedWithMe.length">
              Nobody has shared a workspace with you yet.
            </div>
            <table mat-table [dataSource]="sharedWithMe" class="mat-elevation-z8" *ngIf="sharedWithMe.length">
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef>Workspace</th>
                <td mat-cell *matCellDef="let ws">
                  <a class="pointer routeClr" (click)="open(ws.workspaceId)">{{ ws.name }}</a>
                </td>
              </ng-container>
              <ng-container matColumnDef="access">
                <th mat-header-cell *matHeaderCellDef>Your access</th>
                <td mat-cell *matCellDef="let ws"><span class="sw-tag">Read only</span></td>
              </ng-container>
              <ng-container matColumnDef="members">
                <th mat-header-cell *matHeaderCellDef>People</th>
                <td mat-cell *matCellDef="let ws">{{ ws.memberCount || 1 }}</td>
              </ng-container>
              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let ws">
                  <button mat-button class="routeClr" (click)="open(ws.workspaceId)">Open</button>
                  <button mat-button (click)="leave(ws)" [disabled]="busy">Leave</button>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="['name', 'access', 'members', 'actions']"></tr>
              <tr mat-row *matRowDef="let row; columns: ['name', 'access', 'members', 'actions']"></tr>
            </table>
          </section>

        </ng-container>

      </div>
    </div>
  </div>
</div>
